import type { MeasurementCoverage } from '@/api/types'
import { formatInteger, formatPercent } from '@/design'
import { formatDateKey, toDateKey } from '@/lib/filters'

import { NO_FIGURE } from './figures'

/** What the funnel can see, in the Overview funnel's words: the API's sentence, when measuring began, and how much commerce it can tie to a session. */
export function Coverage({ coverage }: { coverage: MeasurementCoverage }) {
  const share = coverage.ordersWithSessionShare
  return (
    <div className="fun-coverage" data-testid="funnel-coverage">
      <p className="fun-note">{coverage.note}</p>
      <dl className="fun-facts">
        {coverage.firstEventAt ? (
          <div>
            <dt>First measured event</dt>
            <dd>{formatDateKey(toDateKey(new Date(coverage.firstEventAt)), true)}</dd>
          </div>
        ) : null}
        <div>
          <dt>Measured sessions</dt>
          <dd>{formatInteger(coverage.sessionsMeasured)}</dd>
        </div>
        <div>
          <dt>Orders with a measured session</dt>
          <dd>
            {share === null
              ? NO_FIGURE
              : `${formatPercent(share, 0)} (${formatInteger(coverage.ordersWithSession)} of ${formatInteger(coverage.orders)})`}
          </dd>
        </div>
      </dl>
    </div>
  )
}
